import { render, staticRenderFns } from "./CChartBarRounded.vue?vue&type=template&id=3a46c4cc"
import script from "./CChartBarRounded.vue?vue&type=script&lang=js"
export * from "./CChartBarRounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports